import logger from '@/logger';

export const SERVICE_WORKER_URL = '/sw.js';

/**
 * Payload que o consumer do acerto-push (BE-24230) envia e o service worker (public/sw.js) exibe.
 * `deeplink` é um caminho relativo à origem da PWA.
 */
export interface NotificacaoPushPayload {
  titulo: string;
  corpo: string;
  /** Omitido quando o template não tem ícone; o service worker usa o ícone padrão. */
  icone?: string;
  /** `mensagemId` do lembrete no acerto-push. */
  tag: string;
  data: {
    deeplink: string;
    /** Repassado nos eventos da notificação; vai `null` quando ausente. */
    envioId?: string;
    /** Dono da notificação, repassado nos eventos dela; vai `null` quando ausente. */
    userId?: string;
  };
}

export async function registrarServiceWorker(): Promise<ServiceWorkerRegistration | undefined> {
  if (!('serviceWorker' in navigator)) return undefined;

  try {
    return await navigator.serviceWorker.register(SERVICE_WORKER_URL);
  } catch (error) {
    logger.error.andTrackError(error instanceof Error ? error : new Error(String(error)));
    return undefined;
  }
}
